import StudentPlacementForm from "./StudentPlacementForm";
import StaffPlacementForm from "./StaffPlacementForm";

export default {
  StudentPlacementForm,
  StaffPlacementForm
};
